import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import AutocompleteInput from "@Shared/components/inputs/autocomplete-input.vue";
import { computed, defineComponent, ref, toRefs, watch, nextTick } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseLabel from "../base/base-label.vue";
import BaseFieldLayout from "../base/base-field-layout.vue";
export default defineComponent({
  name: "AddressAutocompleteField",
  components: {
    BaseLabel,
    BaseFieldLayout,
    AutocompleteInput
  },
  props: {
    value: {
      type: null,
      default: 0
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    inputType: {
      type: String,
      default: "text"
    },
    sideGrid: {
      type: Boolean,
      default: false
    },
    companyAddressMode: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ""
    },
    maxLength: {
      type: Number,
      default: null
    },
    onType: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      value,
      maxLength,
      onType
    } = toRefs(props);
    const localValue = ref(value.value);
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    const handleAutocomplete = address => {
      emit("autocomplete", address);
    };
    const handleValueChange = eventValue => {
      valueModel.value = eventValue;
    };
    const localValueLength = computed(() => {
      var _localValue$value$len, _localValue$value;
      return (_localValue$value$len = (_localValue$value = localValue.value) == null ? void 0 : _localValue$value.length) != null ? _localValue$value$len : 0;
    });
    watch(value, newVal => {
      if (maxLength.value && newVal.length > maxLength.value) nextTick(() => {
        valueModel.value = newVal.substring(0, maxLength.value);
      });
      localValue.value = value.value;
    });
    const handleInput = eventValue => {
      if (onType.value) localValue.value = eventValue;
    };
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseInput,
      handleAutocomplete,
      handleValueChange,
      localValue,
      localValueLength,
      handleInput
    };
  }
});